import { CapturePDFButton } from '@/components/Buttons/CapturePDFButton';
import { DownloadButton } from '@/components/Buttons/DownloadButton';
import { GREY } from '@/constants/color';
import { getHorizontalGraphData } from '@/helpers/attribution/chartData';
import { downloadCSV } from '@/helpers/downloadCSV';
import { getDocumentTitle } from '@/helpers/printing';
import { useAppSelector } from '@/store/hooks';
import { selectWebVisitsCreativeData } from '@/store/selectors/attribution/webVisits.selectors';
import { InfoOutlined } from '@mui/icons-material';
import { useCallback, useMemo, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import HorizontalChart from '../Charts/HorizontalChart';

const label = 'Creative';

const CreativeCard = () => {
  const printContainerRef = useRef<HTMLDivElement>(null);

  const { creativeData, creativeDataLoading } = useAppSelector(selectWebVisitsCreativeData);

  const { chartData, csvData } = useMemo(
    () => getHorizontalGraphData(label, creativeData, creativeDataLoading),
    [creativeData, creativeDataLoading],
  );

  const handlerClick = useCallback(() => {
    downloadCSV(csvData, label);
  }, [csvData]);

  const handlePrint = useReactToPrint({
    documentTitle: getDocumentTitle(label),
    content: () => printContainerRef.current,
  });

  return (
    <div className='flex flex-col justify-between w-full print:p-4' ref={printContainerRef}>
      <div className='flex justify-between'>
        <div className='flex items-center gap-2'>
          <div className='text-lg text-[#2E2C34] font-semibold'>{label}</div>
          <InfoOutlined sx={{ width: '16px', height: '16px', color: GREY, displayPrint: 'none' }} />
        </div>
        <div className='space-x-[6px] flex-row flex'>
          <DownloadButton onClick={handlerClick} />
          <CapturePDFButton onClick={handlePrint} />
        </div>
      </div>
      <div className='text-lg w-full flex justify-center'>
        <HorizontalChart chartData={chartData} loading={creativeDataLoading} />
      </div>
    </div>
  );
};

export default CreativeCard;
